import { type ButtonHTMLAttributes } from 'react';

export interface FormSubmitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
  alignRight?: boolean;
}

export function FormSubmitButton({
  isLoading = false,
  loadingText = 'Ładowanie...',
  children,
  className,
  disabled,
  type = 'submit',
  alignRight = false,
  ...props
}: FormSubmitButtonProps) {
  const baseClassName = alignRight ? 'btn btn-primary ms-auto' : 'btn btn-primary w-100';
  const finalClassName = className || baseClassName;

  return (
    <button type={type} className={finalClassName} disabled={isLoading || disabled} {...props}>
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
          {loadingText}
        </>
      ) : (
        children
      )}
    </button>
  );
}
